import React from 'react';
import {
	defineMessages,
	useIntl,
} from 'react-intl';

import DonutPagesChart from '../components/DonutPagesChart';



const messages = defineMessages({
	good: {
		id: 'ui.screen.pagesGraphs.webVitals.good',
	},
	needsImprovement: {
		id: 'ui.screen.pagesGraphs.webVitals.needsImprovement',
	},
	poor: {
		id: 'ui.screen.pagesGraphs.webVitals.poor',
	},
});



type Props = {
	data: Array<{
		count: number;
		percentage: number;
		value: string;
	}>;
	field: string;
};



const WebVitalsChart: React.FC<Props> = (props) => {
	const {
		data,
		field,
	} = props;

	const intl = useIntl();

	const categories = [
		{
			value: 'good',
			label: intl.formatMessage(messages.good),
			color: '#0cce6b',
		},
		{
			value: 'needsImprovement',
			label: intl.formatMessage(messages.needsImprovement),
			color: '#ffa400',
		},
		{
			value: 'bad',
			label: intl.formatMessage(messages.poor),
			color: '#ff4e42',
		},
	];

	return (
		<DonutPagesChart
			categories={categories}
			data={data}
			name={field}
			percentageFactor={100}
		/>
	);
};



export default React.memo(WebVitalsChart);
